export default __webpack_public_path__ + "navigation-examples-route-deserialize-1200-21fee44f364a7072353d9f486cffa974.png";